export default {
  magazine: {
    magazine: 'Magazine',
    article: 'Article',
    category: 'Category',

    footerLinks: {
      title: 'Our topics',
    },

    articlePage: {
      header: {
        description:
          'Get creative yourself and discover over {eventCount} courses. Find and book now.',
      },
      datePrefix: 'Updated on',
      supplierProfileSubtitle: 'Partner and writer',
      relatedArticles: {
        sectionTitle: 'Related Articles',
      },
      supplierEvents: {
        sectionTitle: 'Discover classes of {partnerName}',
      },
    },
  },
}
